module.exports = "/_next/static/images/bg-info-extend-2-0b992256.png";